import { ShoppingCartIcon } from '@heroicons/react/24/solid'
import ButtonLink from 'components/ui/ButtonLink'

const EmptyCart = ({ locationUrl }: { locationUrl?: string }) => (
  <div className="pt-10 h-[70vh] flex flex-col justify-center items-center">
    <ShoppingCartIcon className="h-20 w-20 text-gray-200" />
    <p className="pt-8 md:text-2xl italic text-gray-400 font-light">
      Your cart is empty
    </p>
    <div className="mt-6">
      <ButtonLink
        color="primary"
        href={locationUrl || '/food-trucks-near-me'}
        variant="outline"
      >
        Go back
      </ButtonLink>
    </div>
  </div>
)

export default EmptyCart
